// import qs from 'qs';
/**
 * Handles filtering a VueTable by provided filter fields and values
 */
export default {
    methods: {},
    created() {
        let filters = {};
        let hideCat = this.hideType || false;

        for(var prop in this.$route.query) {
            if(prop === 'sectors') {
                filters[prop] = this.$route.query[prop].split(',').map(Number);
            } else if(prop === 'dealType' || prop === 'deal_type' || prop === 'member') {
                filters[prop] = Number(this.$route.query[prop].split(',')[0]);
            } else {
                filters[prop] = this.$route.query[prop].split(',')[0];
            }
        }

        if(hideCat) {
            delete filters.category;
        }

        this.filters = Object.assign(this.filters, filters);
    },
    computed: {
        querystring() {
            let query = {};
            let hideCat = this.hideType || false;

            for(let prop in this.filters) {
                let value = this.filters[prop];

                if(Array.isArray(value)) {
                    if(value.length) {
                        query[prop] = value.join(',');
                    }
                } else if(value !== null && value !== undefined && value !== '') {
                    query[prop] = value;
                }
            }

            if(hideCat){
                delete query.category;
            }

            return query;
        },
    },
    watch: {
        filters: {
            deep: true,
            handler() {
                this.$router.replace({query: this.querystring});
            },
        },
    },
}
